'use client';

import React, { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import GlobalToolbar from '@/components/GlobalToolbar';
import { useAuth } from '@/contexts/AuthContext';

interface AppLayoutProps {
  children: React.ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps) {
  const { user, loading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (!loading && !user) {
      router.replace('/sign-up-login-screen');
    }
  }, [user, loading, router]);

  // While checking auth state, show a blank dark screen (no flash of content)
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: '#0d1526' }}>
        <div className="w-8 h-8 rounded-full border-2 border-primary border-t-transparent animate-spin" />
      </div>
    );
  }

  // Not authenticated — render nothing while redirect fires
  if (!user) {
    return null;
  }

  return (
    <div className="min-h-screen bg-background">
      <GlobalToolbar />
      <main className="pt-14">
        {children}
      </main>
    </div>
  );
}